import React, { useEffect, useState } from 'react';
import { Form, Button, Card, InputGroup, Spinner } from 'react-bootstrap';
import { FaUser } from 'react-icons/fa';
import { Formik, Form as FForm } from 'formik';
import { string, object, InferType } from 'yup'; // for only what you need
import { useWhyDidYouUpdate } from '../../hooks';
import withSizes from 'react-sizes';
import { useHistory } from 'react-router-dom';
import { GridLinkButton } from 'components/common';
// import { AppStore } from 'store/app-store';
import { useRootStore } from 'store';
import { useLazyQuery } from '@apollo/client';
import { COLLECTIONPOINT_LOGIN } from './graphql';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';

/**
 * Setup Yup Validation
 */
const validationSchema = object().shape({
  vatNumber: string().required(),
});

export type FormDataType = InferType<typeof validationSchema>;

type Props = {
  message?: string | null;
  loading?: boolean;
  onSubmit: (values, action) => void;
  isMobile?: boolean;
};

const LoginForm = ({ message = '', loading = false, onSubmit, isMobile }: Props) => {
  /*-------------------- Body -----------------------------------------------*/
  const { appStore } = useRootStore();
  const [errorMsg, setErrorMsg] = useState('');

  useWhyDidYouUpdate('[LoginForm]', { message, onSubmit });
  const history = useHistory();

  // const [loginQuery, { loading: queryLoading, data, error }] = useLazyQuery(COLLECTIONPOINT_LOGIN);

  const [loginQuery, { loading: queryLoading }] = useLazyQuery(COLLECTIONPOINT_LOGIN, {
    errorPolicy: 'all',
    onCompleted: (data) => {
      console.log('[LoginForm] loginQuery completed with data:', data);

      if (data?.collectionpointLogin) {
        runInAction(() => {
          appStore.login(data.collectionpointLogin.collectionpointId, data.collectionpointLogin);
        });
        setTimeout(() => {
          window.location.reload();
        }, 100);
      } else {
        // Login failed – user doesn't exist
        setErrorMsg('Δε βρέθηκε σημείο συλλογής.');
      }
    },

    onError: (error) => {
      // Handle error for backend login failure
      console.log('[LoginForm] loginQuery completed with error:', error);
      const msg = error.graphQLErrors?.[0]?.message || 'Σφάλμα σύνδεσης.';
      setErrorMsg(msg);
    },
  });

  // useEffect(() => {
  //   if (data?.collectionpointLogin) {
  //     runInAction(() => {
  //       appStore.login(data.collectionpointLogin.collectionpointId, data.collectionpointLogin);
  //     });
  //     history.replace('/home');
  //   }
  // }, [data]);

  /*-------------------- Render ---------------------------------------------*/

  return (
    <Formik
      initialValues={{ vatNumber: '' }}
      validationSchema={validationSchema}
      onSubmit={({ vatNumber }) => {
        loginQuery({ variables: { search: vatNumber } });
      }}
    >
      {(formikBag) => (
        <Card
          className="bg-light shadow-sm p-3 mb-5 login-size"
          style={{
            minWidth: isMobile ? '90%' : '640px',
            width: isMobile ? '90%' : '640px',
          }}
        >
          <Card.Body>
            <Card.Title className="text-center mb-4 mt-1" as="h4">
              <img
                alt=""
                src={process.env.PUBLIC_URL + '/logo.png'}
                className="mx-auto d-block"
                style={{
                  fontSize: isMobile ? '0.75rem' : '1rem',
                  width: isMobile ? '70%' : undefined,
                }}
              />
            </Card.Title>
            {/* <p className="text-danger text-center">{message && ''}</p> */}
            <Form as={FForm}>
              <Form.Group>
                <InputGroup>
                  <InputGroup.Text>
                    <FaUser />
                  </InputGroup.Text>
                  {isMobile ? (
                    <Form.Control
                      size="lg"
                      className="rounded-right"
                      id="vatNumber"
                      type="text"
                      placeholder="Σύνδεση με Τηλέφωνο"
                      {...formikBag.getFieldProps('vatNumber')}
                      isInvalid={!!formikBag.touched.vatNumber && !!formikBag.errors.vatNumber}
                    />
                  ) : (
                    <Form.Control
                      className="rounded-right"
                      id="vatNumber"
                      type="text"
                      placeholder="Σύνδεση με Τηλέφωνο"
                      {...formikBag.getFieldProps('vatNumber')}
                      isInvalid={!!formikBag.touched.vatNumber && !!formikBag.errors.vatNumber}
                    />
                  )}

                  <Form.Control.Feedback type="invalid">
                    Το ΑΦΜ/Τηλέφωνο απαιτείται. Δεν μπορεί να είναι κενό
                  </Form.Control.Feedback>
                  {errorMsg && (
                    <Form.Control.Feedback
                      type="invalid"
                      className="d-block text-danger mt-2 font-weight-bold"
                    >
                      Σφάλμα: {errorMsg}
                    </Form.Control.Feedback>
                  )}
                </InputGroup>
              </Form.Group>

              {isMobile ? (
                <Button
                  block
                  variant="primary"
                  size="lg"
                  style={{ fontSize: '0.8rem' }}
                  type="submit"
                  disabled={!(formikBag.isValid && formikBag.dirty)}
                >
                  {queryLoading && <Spinner animation="border" size="sm" className="mx-4" />}
                  <span>{'Είσοδος'}</span>
                </Button>
              ) : (
                <Button
                  block
                  variant="primary"
                  size="sm"
                  style={{ fontSize: '0.8rem' }}
                  type="submit"
                  disabled={!(formikBag.isValid && formikBag.dirty && !queryLoading)}
                >
                  {queryLoading && <Spinner animation="border" size="sm" className="mx-4" />}
                  <span>{'Είσοδος'}</span>
                </Button>
              )}
            </Form>
          </Card.Body>
        </Card>
      )}
    </Formik>
  );
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 768,
});
export default withSizes(mapSizesToProps)(observer(LoginForm));
